import storeInfo from '../store'
import { InspectionReportDetail, InspectionReportsResponse } from '../types'


export const getInspectionReportById = (id: string): InspectionReportDetail | null | undefined => {
  const { inspectionReports } = storeInfo.store.getState()
  return inspectionReports.inspectionReportData || null
}

export const getInspectionReports = (): InspectionReportsResponse | null => {
  const { inspectionReports } = storeInfo.store.getState()
  return inspectionReports.inspectionReports || null
}